export const CACHE_SERVICE_TIMESTAMP_KEY = '_createdAt';

export const CACHE_SERVICE_TIME_KEY = '_cacheTimestamp';

export const CACHE_SERVICE_VERSION_KEY = '_version';
